<app-header-style-one></app-header-style-one>
<!-- <div *ngFor="let x of jobsScrollData" class="marquee">
    <marquee behavior="" direction="">{{x.message}}.</marquee>
</div> -->
<div class="marquee" style="display: flex;">
    <div class="container" style="display: flex;">
        <strong style="white-space: nowrap; margin-right: 10px;color: #fff;">Job Updates:</strong>
        <marquee behavior="scroll" direction="left" scrollamount="6" style="flex: 1;" onmouseover="this.stop();"
            onmouseout="this.start();">
            <span *ngFor="let x of melanotifcations; let last = last">
                <img src="assets/img/mepma/mic.svg" alt="" style="width: 24px;height: 24px;"> {{ x.mela_name }} <span
                    class="blinking"> *Apply Now* </span><span *ngIf="!last"> | </span>
            </span>
        </marquee>
    </div>
</div>


<!-- <app-homeone-main-banner></app-homeone-main-banner> -->
<!-- <app-about-page-one></app-about-page-one> -->

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li>&nbsp;</li>
            </ul>
            <h2>&nbsp;</h2>
        </div>
    </div>
</div>

<br>

<div class="container">
    <mat-card class="cardWithShadow theme-card">
        <h3 style="text-align: center;padding: 18px;">Job Registration</h3>
        <mat-card-content class="b-t-1">
            <form [formGroup]="registrationform" (ngSubmit)="submitMakePaymentDetails()">
                <div class="row">
                    <!-- <div class="col-lg-3">
                        <label> <strong>Are you SHG/SHG Family Member <span
                                    style="color: red;">*</span></strong></label><br>
                        <div style="display: flex;gap: 18px;margin-top: 16px;">
                            <label><input type="radio" formControlName="are_you_shg" value="Yes"> SHG
                                Member</label>
                            <label><input type="radio" formControlName="are_you_shg" value="No"> SHG Family
                                Member</label>
                        </div>
                    </div> -->
                </div>
                <!-- <hr> -->
                <!-- <div class="row">
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select District <span style="color: red;">*</span></label>
                        <ng-select (change)="getUlbData($event)" placeholder="Select District"
                            formControlName="district_id">
                            <ng-option value="" selected disabled>Select District</ng-option>
                            <ng-option [value]="d.district_id"
                                *ngFor="let d of districtData">{{d.district_name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select ULB<span style="color: red;">*</span> </label>
                        <ng-select (change)="getadminSlfReport($event)" placeholder="Select ULB"
                            formControlName="ulb_id">
                            <ng-option value="" selected disabled>Select ULB</ng-option>
                            <ng-option [value]="u.ulb_id" *ngFor="let u of ulbData">{{u.ulb_name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select SLF<span style="color: red;">*</span></label>
                        <ng-select placeholder="Select SLF" formControlName="slf_id">
                            <ng-option value="" selected disabled>Select SLF</ng-option>
                            <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select SHG Group<span style="color: red;">*</span></label>
                        <ng-select placeholder="Select SHG Group" formControlName="shg_id">
                            <ng-option value="" selected disabled>Select SHG Group</ng-option>
                            <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;">
                        <label for="">Select Member Id<span style="color: red;">*</span></label>
                        <ng-select placeholder="Select Member Id" formControlName="member_id">
                            <ng-option value="" selected disabled>Select Member Id</ng-option>
                            <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-3" style="margin-bottom: 18px;"
                        *ngIf="registrationform.get('are_you_shg').value == 'No'">
                        <label for="">Relation with SHG <span style="color: red;">*</span></label>
                        <ng-select placeholder="Relation with SHG " formControlName="relation_with_shg">
                            <ng-option value="" selected disabled>Relation with SHG </ng-option>
                            <ng-option [value]="s.slf_id" *ngFor="let s of slfData">{{s.slf_name}}</ng-option>
                        </ng-select>
                    </div>
                </div> -->
                <!-- <h5>Personal Information</h5> -->
                <div class="row">
                    <!-- Full Name -->

                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="full_name"
                                readonly>
                            <label>Full Name<span style="color: red;">*</span></label>
                            <!-- <div class="invalid">
                                <span>Please Enter Full Name.</span>
                            </div> -->
                        </div>
                    </div>

                    <!-- Father's / Husband's Name -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" "
                                formControlName="father_or_husband_name" readonly>
                            <label>Father’s / Husband’s Name <span style="color: red;">*</span></label>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper" style="text-align: center;">
                            <input type="file" accept="image/*" #fileInput hidden>
                            <img [src]=" photoPreview ? photoPreview :'assets/img/mepma/profile.png'" alt="Upload"
                                style="width: 100px; height: 100px; cursor: pointer; border: 2px dashed #ccc;
                                border-radius: 10px; padding: 10px;margin-bottom: 10px;" /><br>
                        </div>
                    </div>

                    <!-- Date of Birth -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="date" class="custom-mat-input" placeholder=" " formControlName="date_of_birth"
                                readonly>
                            <label>Date of Birth<span style="color: red;">*</span></label>
                        </div>
                    </div>

                    <!-- Gender -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="gender"
                                readonly>
                            <label>Gender<span style="color: red;">*</span></label>
                            <!-- <div class="invalid">
                                <span>Please Enter Full Name.</span>
                            </div> -->
                        </div>
                    </div>
                    <!-- <div class="col-lg-4">
                        <label>Gender<span style="color: red;">*</span></label>
                        <div style="display: flex;gap: 18px;">
                            <label><input type="radio" formControlName="gender" value="Male"> Male</label>
                            <label><input type="radio" formControlName="gender" value="Female"> Female</label>
                            <label><input type="radio" formControlName="gender" value="Other"> Other</label>
                        </div>
                    </div> -->

                    <!-- Contact Number -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="contact_number"
                                maxlength="10" readonly>
                            <label>Contact Number<span style="color: red;">*</span></label>
                        </div>
                    </div>

                    <!-- Email ID -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="email" class="custom-mat-input" placeholder=" " formControlName="email"
                                readonly>
                            <label>Email ID<span style="color: red;">*</span></label>
                        </div>
                    </div>

                    <!-- Aadhaar Number -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <input type="text" class="custom-mat-input" placeholder=" " formControlName="aadhaar_number"
                                maxlength="12" readonly>
                            <label>Aadhaar Number<span style="color: red;">*</span></label>
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="col-lg-4">
                        <div class="custom-mat-input-wrapper">
                            <textarea class="custom-mat-input" rows="1" placeholder=" " formControlName="address"
                                readonly></textarea>
                            <!-- <label>Address<span style="color: red;">*</span></label> -->
                        </div>
                    </div>
                </div>
                <div style="text-align: right;">
                    <button class="addcomp" (click)="addMorecompanies()">Add Companies</button>
                </div>
                <div formArrayName="companyDetails">
                    <div class="row" *ngFor="let f of companyDetails.controls; let i = index" [formGroupName]="i">
                        <div class="col-5" style="margin-bottom: 18px;">
                            <label for="">Select Company <span style="color: red;">*</span></label>
                            <ng-select placeholder="Select Company" formControlName="company_name"
                                (change)="onCompanyChange(i)">
                                <ng-option value="" selected disabled>Select Company</ng-option>
                                <ng-option [value]="d.company_name"
                                    *ngFor="let d of companiesList">{{d.company_name}}</ng-option>
                            </ng-select>
                            <div *ngIf="submittedregist && f.get('company_name')?.errors">
                                <div *ngIf="f.get('company_name')?.errors" class="errormessage"> Please Select Company.
                                </div>
                            </div>
                        </div>
                        <div class="col-5" style="margin-bottom: 18px;">
                            <label for="">Select Position<span style="color: red;">*</span> </label>
                            <ng-select placeholder="Select Position" formControlName="position">
                                <ng-option value="" selected disabled>Select Position</ng-option>
                                <ng-option [value]="u.position"
                                    *ngFor="let u of filteredPositions[i]">{{u.position}}</ng-option>
                            </ng-select>
                            <div *ngIf="submittedregist && f.get('position')?.errors">
                                <div *ngIf="f.get('position')?.errors" class="errormessage"> Please Select Position.
                                </div>
                            </div>
                        </div>
                        <div class="col-2" style="display: flex;align-items: center;"
                            *ngIf="companyDetails.length > 1 ">
                            <button type="button" class="addcomp" (click)="removecompanies(i)"
                                style="margin-top: -18px;background-color: #b51f00;border: #b51f00;">Remove</button>
                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;margin-top: 18px;">
                        <button class="reg-btn"> Click Here to Make Payment </button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>

<div *ngIf="showloader" class="overlap">
    <div class="loader"></div>
</div>